import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';
import { lastValueFrom } from 'rxjs';

import { DialogDocument } from '../../data/models/dialog.model';

@Injectable()
export class ListDialogsService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  params = new HttpParams();

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) {}

  async listDialogs(): Promise<DialogDocument[]> {
    let sectionId = this.common.getSelectedSection().sectionId;

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);
    //let selectedUser = this.common.selectedUserId;
    let selectedUser = this.common.getSelectedUserId();

    this.headers = this.headers
      .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    this.params = this.params.set('givenTo', selectedUser).set('count', '100');

    var result = await lastValueFrom(
      this.httpClient.get<DialogDocument[]>(`${apiConfig.uri}/licence/${sectionId}/dialogs`, {
        headers: this.headers,
        params: this.params
      })
    );
    return result;
  }
}
